// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './MainPage';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* All paths handled by MainPage now */}
        <Route path="/*" element={<MainPage />} />
      </Routes>
    </Router>
  );
};

export default App;
